(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["image-with-text-overlay"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('fctr-overlay-video-toggle')) {
    customElements.define('fctr-overlay-video-toggle', class extends HTMLElement {
      connectedCallback() {
        const video = this.closest('.fctr-media-overlay')?.querySelector('video');
        const button = this.querySelector('button');
        if (!video || !button) return;

        this.controller?.abort();
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        const update = () => {
          button.toggleAttribute('data-paused', video.paused);
          button.setAttribute('aria-label', video.paused ? button.dataset.playLabel : button.dataset.pauseLabel);
        };
        const respectMotion = () => {
          if (motion.matches) {
            video.autoplay = false;
            video.pause();
          }
        };

        button.hidden = false;
        button.addEventListener('click', () => {
          if (video.paused) {
            video.play().catch(update);
          } else {
            video.pause();
          }
        }, options);
        video.addEventListener('play', update, options);
        video.addEventListener('pause', update, options);
        motion.addEventListener('change', respectMotion, options);
        respectMotion();
        update();
      }

      disconnectedCallback() {
        this.controller?.abort();
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
